import { Bold } from './Bold.js';
import { BulletList } from './BulletList.js';
import { Italic } from './Italic.js';
import { Link } from './Link.js';
import { OrderedList } from './OrderedList.js';
import { Strike } from './Strike.js';
import { Subscript } from './Subscript.js';
import { Superscript } from './Superscript.js';
import { Underline } from './Underline.js';
export const RichTextEditorIcons = {
    Bold,
    BulletList,
    Italic,
    Link,
    OrderedList,
    Strike,
    Subscript,
    Superscript,
    Underline,
};
export default RichTextEditorIcons;
